import { Link, useLocation } from "react-router-dom";
import PageShell from "@/components/PageShell";
import { ArrowRight } from "@phosphor-icons/react";

export default function Login() {
  const location = useLocation();
  const next = new URLSearchParams(location.search).get("next") || "/teams";

  const googleLogin = () => {
    const redirectUrl = window.location.origin + next;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <PageShell
      eyebrow="Sign in"
      title="Welcome to SendMe."
      subtitle="One tap with Google. Team members don't need to sign in — they join a team with just the Team ID + password."
      narrow
    >
      <div className="grid lg:grid-cols-[1.1fr_1fr] gap-8 items-start">
        <div className="brut-card p-6" data-testid="login-card">
          <div className="mb-4">
            <div className="small-caps mb-3">Sign in</div>
            <p className="text-sm text-black/70 leading-relaxed">
              SendMe uses Google sign-in only. We don't store passwords for regular accounts —
              one less thing to leak. Sign in with any Google account (personal, Workspace, or
              school).
            </p>
          </div>

          <button
            onClick={googleLogin}
            data-testid="google-login-btn"
            className="btn-brut-primary w-full !py-4 text-base"
          >
            Continue with Google <ArrowRight size={18} weight="bold" />
          </button>

          <div className="mt-6 text-[11px] text-black/50 font-mono leading-relaxed">
            By continuing you agree to our <Link to="/terms" className="underline">Terms</Link>{" "}
            and <Link to="/privacy" className="underline">Privacy Policy</Link>.
          </div>
        </div>

        <aside className="brut-card p-6 space-y-4 self-start" data-testid="login-side">
          <div className="small-caps">Just joining a team?</div>
          <p className="text-sm text-black/75">
            You don't need to sign in. Go directly to the join page and use the Team ID + password
            your team leader shared with you.
          </p>
          <Link to="/teams/join" className="btn-brut-accent w-full" data-testid="side-join-team">
            Join a team <ArrowRight size={16} />
          </Link>

          <div className="pt-4 border-t border-black/10">
            <div className="small-caps mb-2">Why Google-only?</div>
            <ul className="space-y-1.5 text-sm text-black/70">
              <li>· No passwords to remember or leak</li>
              <li>· Two-factor security from your Google account</li>
              <li>· One tap, works on every device</li>
            </ul>
          </div>
        </aside>
      </div>
    </PageShell>
  );
}
